import React, { Fragment } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import Spinner from "react-webpack-spinner";

import { FaTimes } from "react-icons/fa";
import { Field, reduxForm } from "redux-form";
import { Creatable } from "react-select";
import { Link } from "react-router";

import { isDistrictAdmin } from "../utils/objects";
import SelectInput from "./SelectInput";
import FormField from "./FormField";

const nonArray = value => {
  if (Array.isArray(value)) {
    if (value.length > 0) {
      return value[0];
    }
    return undefined;
  }
  return value;
};

class EditInstitution extends React.Component {
  loadUsers = () => {
    const { institution = {}, user = {}, onLoadUsers } = this.props;
    if (user.is_admin || isDistrictAdmin(user, institution.area)) {
      onLoadUsers();
    }
  };

  submit = e => {
    e.preventDefault();
    this.props.handleSubmit();
  };

  componentWillMount() {
    const { user, paramsKey, onLoadEntry } = this.props;

    this.loadUsers();
    if (user._key && paramsKey) {
      onLoadEntry(paramsKey);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      user,
      paramsKey,
      institution,
      onLoadEntry,
      savingInstitution
    } = this.props;

    if (
      (!!user._key && !prevProps.user._key) ||
      (!!institution.area && !prevProps.institution.area)
    ) {
      this.loadUsers();
    }

    if (paramsKey && !institution._key && user._key) {
      onLoadEntry(paramsKey);
    }

    if (!savingInstitution && prevProps.savingInstitution) {
      ReactDOM.findDOMNode(this).scrollTop = 0;
    }
  }

  render() {
    const {
      institution = {},
      categories,
      districts,
      users,
      loading_users,
      paramsKey,
      saved,
      saveInstitutionFailed,
      saveInstitutionErrors: errors,
      user,
      savingInstitution,
      isLoadingDistricts,
      isLoadingCategories
    } = this.props;

    if (
      savingInstitution ||
      isLoadingDistricts ||
      isLoadingCategories ||
      (paramsKey && (!institution || !institution._key))
    ) {
      return (
        <div className="flex-1-1 has-text-centered">
          <Spinner width={32} height={32} color="#000" />
        </div>
      );
    }

    const maySetOffBorders =
      user.is_admin || isDistrictAdmin(user, institution.area);

    return (
      <div className="content">
        <form onSubmit={this.submit}>
          <Field name="key" component="input" type="hidden" />
          <h1 className="title">
            {institution.name || "Neue Einrichtung anlegen"}
          </h1>

          {saveInstitutionFailed && (
            <div className="notification is-danger">Fehler beim Speichern</div>
          )}

          {saved && (
            <div className="notification is-success">
              Erfolgreich gespeichert
            </div>
          )}

          <FormField
            label="Träger / Institution / Einrichtung / Verein"
            name="name"
            component="input"
            type="text"
            error={errors.name}
          />

          {!!institution._key &&
            (user.is_admin || isDistrictAdmin(user, institution.area)) && (
              <div>
                <label className="label">Datensatz-Admin</label>
                {loading_users ? (
                  <div>
                    <Spinner width={32} height={32} color="#000" /> Lade
                    Benutzerliste...{" "}
                  </div>
                ) : (
                  <Field
                    name="owner"
                    component={props => (
                      <SelectInput
                        placeholder="Datensatz-Admin auswählen"
                        options={users.map(user => ({
                          value: user._key,
                          label: `${user.first_name} ${user.last_name} - ${
                            user.email
                          }`
                        }))}
                        selectedOptions={[props.input.value] || []}
                        onChange={props.input.onChange}
                        multi={false}
                      />
                    )}
                  />
                )}
              </div>
            )}

          <FormField
            label="Kategorien"
            name="categories"
            component={props => (
              <SelectInput
                placeholder="Kategorien auswählen"
                options={categories}
                selectedOptions={props.input.value || []}
                onChange={props.input.onChange}
              />
            )}
            type="text"
            error={errors.categories}
          />

          {maySetOffBorders && (
            <Fragment>
              <FormField
                label="Regionaler Bezug"
                name="offborders"
                component={props => (
                  <SelectInput
                    placeholder="Regionalen Bezug auswählen"
                    multi={false}
                    options={[
                      { value: 0, label: "Stadtteil" },
                      { value: 1, label: "Bezirk" },
                      { value: 2, label: "Stadt" }
                    ]}
                    selectedOptions={[props.input.value] || []}
                    onChange={props.input.onChange}
                  />
                )}
                type="text"
                error={errors.offborders}
              />
            </Fragment>
          )}

          <h2 className="subtitle bold">Adresse</h2>
          <FormField
            label="Stadtteil"
            name="area"
            component={props => (
              <SelectInput
                placeholder="Stadtteil auswählen"
                onClear={props.input.onChange}
                groupFormatter={option => `Bezirk ${option}`}
                options={districts}
                selectedOptions={[props.input.value]}
                onChange={props.input.onChange}
                groupSelectable={false}
                multi={false}
              />
            )}
            error={errors.area}
            normalize={nonArray}
          />
          <FormField
            label="Straße"
            name="address.street"
            component="input"
            type="text"
            error={errors["address.street"]}
          />
          <FormField
            label="PLZ"
            name="address.zipcode"
            component="input"
            maxLength="5"
            type="text"
            error={errors["address.zipcode"]}
          />
          <FormField
            label="Ort"
            name="address.city"
            component="input"
            type="text"
            error={errors["address.city"]}
          />

          <h2 className="subtitle bold">Kontakt</h2>
          <FormField
            label="Ansprechpartner*innen"
            name="contact.contact_person"
            component="input"
            type="text"
            error={errors.contact_person}
          />
          <FormField
            label="Telefon"
            name="contact.phone"
            component="input"
            type="text"
            error={errors.phone}
          />
          <FormField
            label="Kontakt-E-Mail"
            name="contact.email"
            component="input"
            type="text"
            error={errors.email}
          />
          <FormField
            label="Fax"
            name="contact.fax"
            component="input"
            type="text"
            error={errors.fax}
          />
          <FormField
            label="Webseite"
            name="url"
            component="input"
            type="url"
            error={errors.url}
          />
          <FormField
            label="Öffnungszeiten"
            name="opening_hours"
            component="input"
            type="text"
            error={errors.opening_hours}
          />

          <h2 className="subtitle bold">Sonstiges</h2>
          <FormField
            rows="10"
            label="Beschreibung"
            name="description"
            component="textarea"
            type="text"
            error={errors.description}
          />

          <FormField
            label="Angebot in Stichworten"
            name="tags"
            component={props => (
              <Creatable
                placeholder="Stichworte auswählen oder neue anlegen"
                isMulti={true}
                formatCreateLabel={label => `Neues Tag "${label}" erstellen`}
                value={(props.input.value || []).map(item => ({
                  value: item,
                  label: item
                }))}
                onChange={value =>
                  props.input.onChange(value.map(item => item.value))
                }
                noOptionsMessage={() => ""}
              />
            )}
            error={errors.tags}
          />

          {(!!user.is_admin || isDistrictAdmin(user, institution.area)) && (
            <FormField
              label="Freigeschaltet"
              name="approved"
              component="input"
              type="checkbox"
            />
          )}
          <button className="button is-success is-medium" type="submit">
            Speichern
          </button>
          <Link to="/" className="button is-warning is-medium">
            <FaTimes /> Abbrechen
          </Link>
        </form>
      </div>
    );
  }
}

EditInstitution.propTypes = {
  institution: PropTypes.object,
  categories: PropTypes.array,
  districts: PropTypes.array,
  users: PropTypes.array,
  loading_users: PropTypes.bool,
  paramsKey: PropTypes.string,
  saved: PropTypes.string,
  savingInstitution: PropTypes.bool,
  saveInstitutionFailed: PropTypes.bool,
  saveInstitutionErrors: PropTypes.object,
  user: PropTypes.object
};

export default reduxForm({
  form: "institution"
})(EditInstitution);



/** WEBPACK FOOTER **
 ** ./src/components/EditInstitution.jsx
 **/